module.exports = __webpack_public_path__ + "img/extend.da9b170d.svg";